import React, { Component }from "react";

import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink
} from "react-router-dom";

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

import Authentification from '../../Containers/Authentification/Authentification'

import PostsList from '../../Containers/Posts/List'
import PostForm from '../../Containers/Posts/PostForm'

import RestaurantsList from '../../Containers/Restaurants/List'
import RestaurantForm from '../../Containers/Restaurants/RestaurantForm'

import VideosList from '../../Containers/Videos/List'
import VideoForm from '../../Containers/Videos/VideoForm'

import DirectorsList from '../../Containers/Directors/List'
import DirectorForm from '../../Containers/Directors/DirectorForm' 

import AboutsList from '../../Containers/Abouts/List'
import AboutForm from '../../Containers/Abouts/AboutForm' 

import UsersList from '../../Containers/Users/List'
import UserForm from '../../Containers/Users/UserForm' 

import FeedBackCategoriesList from '../../Containers/FeedBackCategories/List'
import FeedBackCategoryForm from '../../Containers/FeedBackCategories/FeedBackCategoryForm' 

import FeedBacksList from '../../Containers/FeedBacks/List'
import FeedBackForm from '../../Containers/FeedBacks/FeedBackForm' 

import GaleriesList from '../../Containers/Galeries/List'
import GaleryForm from '../../Containers/Galeries/GaleryForm' 

import EventOptionsList from '../../Containers/EventOptions/List'
import EventOptionForm from '../../Containers/EventOptions/EventOptionForm' 

import EventsList from '../../Containers/Events/List'
import EventForm from '../../Containers/Events/EventForm' 
 
import {Rest} from "../../Helpers/Rest" 
import {check_roles} from "../../Helpers/Roles"

try{
    var user_data = JSON.parse(localStorage.getItem("user_data"))
    if(!user_data){
        user_data = {}
    }
}catch(e){ 
    var user_data = {}
}

const routes = [
    {
        url: "/posts/list",
        component: PostsList
    },
    {
        url: "/posts/:method/:id",
        component: PostForm
    },
    {
        url: "/posts/:method",
        component: PostForm
    },

    {
        url: "/restaurants/list",
        component: RestaurantsList
    },
    {
        url: "/restaurants/:method/:id",
        component: RestaurantForm
    },
    {
        url: "/restaurants/:method",
        component: RestaurantForm
    },


    {
        url: "/videos/list",
        component: VideosList
    },
    {
        url: "/videos/:method/:id",
        component: VideoForm
    },
    {
        url: "/videos/:method",
        component: VideoForm
    }, 

    {
        url: "/directors/list",
        component: DirectorsList
    },
    {
        url: "/directors/:method/:id",
        component: DirectorForm
    },
    {
        url: "/directors/:method",
        component: DirectorForm
    },
 

    {
        url: "/abouts/list",
        component: AboutsList
    },
    {
        url: "/abouts/:method/:id",
        component: AboutForm
    },
    {
        url: "/abouts/:method",
        component: AboutForm
    },


    {
        url: "/feedback_categories/list",
        component: FeedBackCategoriesList
    },
    {
        url: "/feedback_categories/:method/:id",
        component: FeedBackCategoryForm
    },
    {
        url: "/feedback_categories/:method",
        component: FeedBackCategoryForm
    },

    {
        url: "/galeries/list",
        component: GaleriesList
    },
    {
        url: "/galeries/:method/:id",
        component: GaleryForm
    },
    {
        url: "/galeries/:method",
        component: GaleryForm
    },
 

    {
        url: "/feedbacks/list",
        component: FeedBacksList
    },
    {
        url: "/feedbacks/:method/:id",
        component: FeedBackForm
    },
    {
        url: "/feedbacks/:method",
        component: FeedBackForm
    },
 

    {
        url: "/event_options/list",
        component: EventOptionsList
    },
    {
        url: "/event_options/:method/:id",
        component: EventOptionForm
    },
    {
        url: "/event_options/:method",
        component: EventOptionForm
    },
 

    {
        url: "/events/list",
        component: EventsList
    },
    {
        url: "/events/:method/:id",
        component: EventForm
    },
    {
        url: "/events/:method",
        component: EventForm
    },
 

    {
        url: "/users/list",
        component: UsersList
    },
    {
        url: "/users/:method/:id",
        component: UserForm
    },
    {
        url: "/users/:method",
        component: UserForm
    },


    {
        url: "/authentification",
        component: Authentification
    },
]
class Menu extends Component {

    constructor(props) {
        super(props);
        this.state = { 
        };
      }

    componentDidMount() {
        var rest = new Rest(this) 
        rest.request("whoami", "GET", {}, (res)=>{
            if(!res.errors){
                Object.keys(res).forEach(k=>{
                    user_data[k] = res[k];
                })
                localStorage.setItem( "user_data", JSON.stringify(user_data) ) 
                this.setState(res)
            }
            
        })
    }

    exit = () => { 
        document.location.href = "/authentification"
        localStorage.setItem( "user_data", JSON.stringify({}) )
    }

    render_with_access_check = (roles=[], el) =>{
        if(check_roles(["admin"].concat(roles))){
            return el
        }
    }

    render() { 
        return (
            <Router>
                <div>
                 
                <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
                    <Navbar.Brand href="/">Corpo Web Administration</Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="mr-auto">
                            { this.render_with_access_check(["posts","videos","directors","abouts", "feedbacks", "galeries", "events", "restaurants"], //accees on dropdown element
                                <NavDropdown title="Content" id="basic-nav-dropdown">
                                    { /*this.render_with_access_check("posts", <NavDropdown.Item as={NavLink} to="/posts/list">Posts</NavDropdown.Item>)*/} 
                                    { this.render_with_access_check("videos",  <NavDropdown.Item as={NavLink} to="/videos/list">Videos</NavDropdown.Item>)}
                                    { this.render_with_access_check("galeries",  <NavDropdown.Item as={NavLink} to="/galeries/list">Galeries</NavDropdown.Item>)} 
                                    { this.render_with_access_check("directors", <NavDropdown.Item as={NavLink} to="/directors/list">Board of Directors</NavDropdown.Item>)} 
                                    { this.render_with_access_check("abouts", <NavDropdown.Item as={NavLink} to="/abouts/list">About company</NavDropdown.Item>)} 
                                    { this.render_with_access_check("feedbacks", <NavDropdown.Item as={NavLink} to="/feedbacks/list">Feedbacks</NavDropdown.Item>)}
                                    { this.render_with_access_check("events", <NavDropdown.Item as={NavLink} to="/events/list">Events</NavDropdown.Item>)}
                                    { this.render_with_access_check("restaurants", <NavDropdown.Item as={NavLink} to="/restaurants/list">Restaurants</NavDropdown.Item>)} 
                                </NavDropdown>)
                            }
                             
                             { this.render_with_access_check(["users","feedback_categories","event_options"], //accees on dropdown element
                                <NavDropdown title="Handbooks" id="basic-nav-dropdown">
                                    { this.render_with_access_check("users", <NavDropdown.Item as={NavLink} to="/Users/list">Users</NavDropdown.Item>)} 
                                    { this.render_with_access_check("feedback_categories",  <NavDropdown.Item as={NavLink} to="/feedback_categories/list">Feedback categories</NavDropdown.Item>  )} 
                                    { this.render_with_access_check("event_options",  <NavDropdown.Item as={NavLink} to="/event_options/list">Options for events</NavDropdown.Item>  )} 
                                          </NavDropdown>)
                            }
 
                            {/*<Nav.Link href="#pricing">Pricing</Nav.Link> */}
                        </Nav>
                        <Nav>
                            <Nav.Link href="#" onClick={this.exit}>Logout ({user_data.login})</Nav.Link> 
                        </Nav>
                    </Navbar.Collapse>
                </Navbar>
 
 
    
                    <Switch> 
                        {
                            routes.map(r=>{
                                return <Route key={r.url} path={r.url}  component={r.component}></Route>
                            })
                        } 
                    </Switch>
                </div>

            </Router>
        );
    }
}

export default Menu;
 